export function Block({ children, name, style }) {
    const className = name ? `${name}__block` : '';
    return (
        <div className={className} style={style}>
            {children}
        </div>
    );
}
